import { ACCOUNT_TYPE, CustomUser } from '../model';

export class UserUtils {
  static isPharmacyUser(user: CustomUser): boolean {
    return !!user?.sapCustomerId;
  }

  static isDirectUser(user: CustomUser): boolean {
    return (
      !user ||
      (UserUtils.isPharmacyUser(user) &&
        user.accountType === ACCOUNT_TYPE.DIRECT)
    );
  }
}
